import {DATE_FORMAT, DATETIME_DB_FORMAT, DATETIME_FORMAT} from '@/core/constants/time.constants'

export default {
    data: () => ({
        globalPageSize: 10
    }),
    computed: {
        baseRoute: function () {
            let baseRoute = '';
            this.$route.matched.forEach(function (route) {
                if (route.meta && route.meta.basePath && route.meta.basePath == true) {
                    baseRoute = route;
                    return;
                }
            })
            return baseRoute;
        },
        currentAward: function () {
            if (this.baseRoute.meta && this.baseRoute.meta.awardName) {
                return this.baseRoute.meta.award;
            }
            return '';
        },
        currentAwardName: function () {
            if (this.baseRoute.meta && this.baseRoute.meta.awardName) {
                return this.baseRoute.meta.awardName;
            }
            return '';
        },
        loginLink: function () {
            return this.baseRoute.path + '/login';
        },
        accountLink: function () {
            return this.baseRoute.path + '/account';
        },
        submissionLink: function () {
            return this.baseRoute.path + '/my-submissions';
        },
        registerLink: function () {
            return this.baseRoute.path + '/register';
        },
        forgotLink: function () {
            return this.baseRoute.path + '/password-reminder';
        },
        isLogged: function () {
            return this.$auth && this.$auth.user();
        },
        currentUserName() {
            let currentUser = this.$auth.user();
            if (currentUser) {
                return ' ' + currentUser.first_name + ' ' + currentUser.last_name;
            }
            return '';
        }
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
        price: function (number) {
            return Number(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\'')
        },
        date: function (datetime) {
            return dayjs(datetime).isValid() ? dayjs(datetime, DATETIME_DB_FORMAT).format(DATE_FORMAT) : ''
        },
        time: function (datetime) {
            return dayjs(datetime).isValid() ? dayjs(datetime, DATETIME_DB_FORMAT).format(DATETIME_FORMAT) : ''
        },
    },
    methods: {
        logout() {

        },
        __(key, replace) {
            let translation, translationNotFound = true

            try {
                translation = window._translations[window._locale].php;
                key.split('.').forEach(function (el, i) {
                    translation = translation[el];
                });

                if (translation) {
                    translationNotFound = false
                }
            } catch (e) {
            }

            if (translationNotFound) {
                translation = key
            }

            _.forEach(replace, (value, k) => {
                translation = translation.replace(':' + k, value)
            })

            return translation
        }
    }
}
